import { NAME as GDPR } from '@/modules/kartoteka/gdpr/constants';

export { DMS_MODULE, PARTNER as NAME } from '../constants';
export const PARTNER_MERGE = 'PartnerMerge';
export const MERGE = 'Merge';
export const CRUMB_LABEL_KEY = 'grdZakaznik';
export const OBRAT = 'PartnerObrat';
export const GDPR_LOG = 'GdprLog';
export const CUSTOMER_HISTORY = 'CustomerHistory';
export const PARTNER_ONGOING_EDITS = 'PARTNER_ONGOING_EDITS';
export const VALIDATE_PAN_GSTIN = 'VALIDATE_PAN_GSTIN';
export const ZAKAZNIK_CDB = 'ZakaznikCDB';
export const MENU_CODE = 'KZV_Zakaznici';
export const DEFAULT_CORPORATE_CUSTOMER_TYPE = 4;
export const RETAIL_CUSTOMER_TYPE = 3;
export const CDB_CUSTOMER_DEFAULTVALUE = 1;
export const CUSTOMER_TYPE_INDIVIDUAL = 'PERSONACCOUNT';
export const CUSTOMER_TYPE_ORGANIZATION = 'BUSINESSACCOUNT';
export const DEFAULT_CUSTOMER_TYPE_INDIVIDUAL_VALUE = 1;
export const DEFAULT_CUSTOMER_TYPE_CORPORATE_VALUE = 2;
export const DEFAULT_CATEGORY_TYPE_FOR_COMPANY = 100;
export const DEFAULT_SALUTATION_MRANDMRS = 9;
export enum OBRAT_TYPE {
	MATERIAL = 'ObratMaterial',
	SLUZBY = 'ObratSluzby',
	CELKEM = 'ObratCelkem',
}
export enum PARTNER_COMMUNICATION_MODE {
	MOBILE = 1,
	EMAIL = 2,
	PMOBILE = 3,
	NO_COMMUNICATION = 0
}
export const PARTNER_TYPE = {
	INSURANCE: 'insurance',
	LEASING: 'leasing',
	ALL: 'all',
};

export const GDR_RESULT = [
	{
		Disabled: false,
		Label: null,
		Text: 'Nesouhlasim',
		Value: 'N',
	},
	{
		Disabled: false,
		Label: null,
		Text: 'Souhlasim',
		Value: 'A',
	},
];
export const NO_TAX = 0;
export const REGULAR_TAX = 1;
export const SOUHLAS_MARK = 3;
export const ZPRACOVOSDAT_ID = 0;
export const NESOUHLAS = 'N';
export const VIN_LAST_SIX_CHARS = 6;
export const SEARCHINCDB_CUSTOMERSCREEN = 'SearchInCDBCustomerScreen';
export const DUMMY_CUSTOMERID = -10000;
export const MSG_LOG = 'MsgLog';
export const DUPLICITY_CHECK = 'Duplicity';
export const CUSTOMER_FILES = 'CustomerFiles';

export const DEPENDENT_TABLES = <const>[
	GDPR,
	MSG_LOG,
	DUPLICITY_CHECK,
	GDPR_LOG,
	CUSTOMER_HISTORY,
	CUSTOMER_FILES,
];

export const DEPENDENT_TABLES_MERGE = <const>[
	MERGE,
];

export enum Staty { CeskaRepublika = 1, SlovenskaRepublika = 2 }

export const OBRAT_FILTER = 'OBRAT_FILTER';

export const VOZIDLO_RIDIC = 'VozidloRidic';
export type DependentTableNames = typeof DEPENDENT_TABLES[number] & typeof DEPENDENT_TABLES_MERGE[number];

export const MERGE_PROPS = {
	fromKVZButton: 'cmdVsetkyKontaktHodnoty',
	fromKontaktButton: 'cmdVsetkyKZVHodnoty',
	updateButton: 'cmdUpdateKZVHodnoty',
	createButton: 'cmdZalozZakaznika',
	duplicateColumnName: 'KontaktHodnoty',
	sourceColumnName: 'ZakaznikHodnoty',
	labelKeyVysledek: 'ZakaznikMergeHodnoty',
};
export enum dataType {
	boolean = 0,
	number = 1,
	string = 2,
	date = 3,
}
// TODO: IND to refactor it into boolean later
export enum VerifiedMode {
	OTPVerified = 'OTP verified',
	OTPNotVerified = 'OTP not verified',
}

export enum TAB_NAMES {
	FINANCEDALSI = 'FinanceDalsi',
	MSGLOG = 'MsgLog',
	REFERENCEPRILOHY = 'ReferencePrilohy',
	SYSTEMOVEUDAJE = 'SystemoveUdaje',
	POZNAMKAOZNAMENI = 'PoznamkaOznameni',
	UPDATEDCUSTOMERDETAILS = 'UpdatedCustomerDetails',
	GDPR = 'Gdpr',
}

export const TABS = {
	[TAB_NAMES.FINANCEDALSI]: { id: TAB_NAMES.FINANCEDALSI, labelKey: 'FinanceDalsi' },
	[TAB_NAMES.MSGLOG]: { id: TAB_NAMES.MSGLOG, labelKey: 'TabSheetMsgLog' },
	[TAB_NAMES.REFERENCEPRILOHY]: { id: TAB_NAMES.REFERENCEPRILOHY, labelKey: 'Reference-prilohy' },
	[TAB_NAMES.SYSTEMOVEUDAJE]: { id: TAB_NAMES.SYSTEMOVEUDAJE, labelKey: 'SystemoveUdaje' },
	[TAB_NAMES.POZNAMKAOZNAMENI]: { id: TAB_NAMES.POZNAMKAOZNAMENI, labelKey: 'PoznamkaOznameni' },
	[TAB_NAMES.UPDATEDCUSTOMERDETAILS]: { id: TAB_NAMES.UPDATEDCUSTOMERDETAILS, labelKey: 'UpdateDetails' },
	[TAB_NAMES.GDPR]: { id: TAB_NAMES.GDPR, labelKey: 'TabSheetGDPR' },
};
